import React from 'react';

import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';

import Chart, {
  AdaptiveLayout,
  CommonSeriesSettings,
  Size,
  Tooltip,
  Label,
  Connector,
  Margin,
  Format,
} from 'devextreme-react/chart';

import PivotGrid, {
  FieldChooser,
  FieldPanel,
  Export,
} from 'devextreme-react/pivot-grid';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import config from 'devextreme/core/config';


import * as nlMessages from "devextreme/localization/messages/nl.json";


import { locale, loadMessages, formatMessage } from "devextreme/localization";

class WastePivotGrid extends React.Component {
  constructor(props) {
    super(props);

    // Specifying a currency globally
    config({
      defaultCurrency: 'EUR', decimalSeparator: ','
    });
}
  componentDidMount() {
    function setLocale(savingLocale) {
      sessionStorage.setItem("locale", savingLocale);
    }
    setLocale("nl-BE");

    loadMessages(nlMessages);
    console.log(nlMessages);
    locale("nl-BE");
    this.pivotGrid.bindChart(this.chart, {
      dataFieldsDisplayMode: 'splitPanes',
      alternateDataFields: false,
    });
    sessionStorage.setItem("locale", "nl-BE");
    config({
      defaultCurrency: 'EUR', decimalSeparator: ','
    });


    setTimeout(() => {
      dataSource(this.props).expandHeaderItem('column', '2021');
    });

  }


  render() {
    return (
      <div style={pivotGridContainer}>
        <Chart ref={(ref) => { this.chart = (ref !== null ? ref.instance : ''); }} palette="Ocean" paletteExtensionMode="blend">
          <Margin
            top={20}
            bottom={20}
            left={30}
            right={30}
          />
          <Size height={300} />
          <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
          <CommonSeriesSettings type="bar">
            <Label visible={true} format="fixedPoint" customizeText={customizeLabel}>
              <Connector visible={true} />
            </Label>
          </CommonSeriesSettings>
          <AdaptiveLayout width={650} />
        </Chart>
        <PivotGrid
          id="pivotgrid"
          style={pivotgrid}
          dataSource={dataSource(this.props)}
          allowSortingBySummary={true}
          allowFiltering={true}
          showBorders={true}
          showColumnTotals={true}
          showColumnGrandTotals={true}
          showRowTotals={true}
          precision={2}
          autoExpandAll={true}
          expanded={true}
          showRowGrandTotals={false}
          format={function (value) {
            return 'test';
          }}
          editorOptions={amountEditorOptions}

          ref={(ref) => { this.pivotGrid = (ref !== null ? ref.instance : ''); }}
          onExporting={exportGrid}>
          <Format type="fixedPoint" decimalSeparator="," precision={2} />

          {/* ... */}
          <Export enabled={true} />
          <FieldPanel
            visible={true}
            showFilterFields={true}
          />
          <FieldChooser enabled={true} height={400} />
        </PivotGrid>

      </div>
    );
  }
}
const amountEditorOptions = {
  format: 'currency',
  showClearButton: true,
};
const pivotGridStyle = {
  width: '100%',
  display: 'flex',
}
const pivotgrid = {
  marginTop: '20px',

}
const pivotGridContainer = {
  width: '100%',
  backgroundColor: 'white',
}

const dataSource = (props) => {
  return (
    new PivotGridDataSource({
      fields: [{
        caption: 'Waste',
        dataField: 'wastestream',
        width: 150,
        area: 'row',
        sortBySummaryField: 'Total',

      }, {
        caption: 'Material',
        dataField: 'material',
        width: 150,
        area: 'row',
      }, {
        caption: 'City',
        width: 120,
        dataField: 'originName',
        area: 'row',
      },
      {
        dataField: 'date',
        dataType: 'date',
        area: 'column',
      },
      {
        groupName: 'date',
        groupInterval: 'month',
        visible: true,
      }, {
        caption: 'Tonnage',
        dataField: 'quantity',
        dataType: 'number',
        summaryType: 'sum',
        format: {
          decimalSeparator: ',',
          seperator: ",",
          type: "fixedPoint",
          precision: 2,
          defaultCurrency: 'EUR'
        },
        decimalSeparator: ',',
        defaultCurrency: 'EUR',
        area: 'data',
      }],
      store: props.data,
    }))
}
function exportGrid(e) {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Wastestreams");
  exportPivotGrid({
    worksheet: worksheet,
    component: e.component
  }).then(function () {
    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), "Wastestreams.xlsx");
    });
  });
  e.cancel = true;
}

const tonnageFormatter = new Intl.NumberFormat(
  'nl-BE', {
  style: 'decimal',
  minimumFractionDigits: 0,
},
);

function customizeTooltip(args) {
  const valueText = tonnageFormatter.format(args.originalValue);
  const percentage = tonnageFormatter.format((args.percent * 100).toFixed(2));

  return {
    html: `${args.seriesName} - Total <div class="tonnage">${valueText} TON</div><div>${percentage}%</div`,
  };
}
function customizeLabel(args) {
  const valueText = tonnageFormatter.format(args.originalValue);
  return ` <div class="tonnage"> ${valueText} TON</div>`;
}
export default WastePivotGrid;
